import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';
import { Post, PostStatus, PostPriority } from '@eview/core/domain/post/post';
import { UsersHelpers } from '@eview/core/users/users.helpers';
import { environment } from '@eview/core';
import { AppState } from '@eview/core/store/states/app.state';
import { Store } from '@ngrx/store';
import { selectUsers } from '@eview/core/store/selectors/users.selector';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { map } from 'rxjs/operators';
import { Permission } from '@eview/core/auth/permission';
import { AuthHelpers } from '@eview/core/auth';
import { Observable , Subscription} from 'rxjs';
import { User } from '../../../../../../../../libs/core/models/user';
import { PostType } from '@eview/core/domain/post/post';
import { Form } from '@eview/core/domain/form/form';
@Component({
  selector: 'eview-post-subtitle',
  templateUrl: 'post-subtitle.component.html',
  styleUrls: ['post-subtitle.component.scss']
})
export class PostSubtitleComponent implements OnInit, OnDestroy {
  constructor(public store: Store<AppState>) {
    // this.user$ = this.store
    // .select(selectUsers)
    // .pipe(
    //   map(users =>
    //     this.post.user && this.post.user.id
    //       ? UsersHelpers.FindUserById(users, this.post.user.id)
    //       : null
    //   )
    // );
  }

  @Input() post: Post;
  @Input() viewOnlyMode: Boolean;
  @Input() disableLinkPost: Boolean;
  @Output() public onShowLinkedPostClick: EventEmitter<Object> = new EventEmitter();

  PostHelpers = PostHelpers;

  UsersHelpers = UsersHelpers;

  PostStatus = PostStatus;

  PostPriority = PostPriority;

  format = environment.format;

  AuthHelpers = AuthHelpers;
  
  Permission = Permission;
  user$: Observable<User>;

  private formsCatalog: Form[] = [];
  private formsSub!: Subscription;

  PostType = PostType;

  viewIdentityPermission$: Observable<any>;

  get managementLevels() {
    return PostHelpers.FormatMgmtLevels(this.post);
  }

  onShowLinkedClick(post: Post) {
    //event.stopPropagation();
    this.onShowLinkedPostClick.emit({
      id: post.id,
      title: PostHelpers.GetPostDisplayTitle(post, this.formsCatalog)
    });
  }

//  viewPost$ = AuthHelpers.User.HasUserPermission(this.store, Permission.AccessIncidentRiskReports);

  
  ngOnInit() { 
    this.formsSub = this.store.select(selectForms).subscribe(forms => {
      this.formsCatalog = forms?.results ? [...forms.results] : [];
    });
    this.viewIdentityPermission$ = AuthHelpers.User.CanForm(
      this.store,
      this.post?.form?.id ?? null,
      'view_identity'
    );
  }

  ngOnDestroy(): void {
    this.formsSub?.unsubscribe();
  }

}
